export const AI_MODEL = 'claude-sonnet-4-6';

// ─── LAYOUT ───────────────────────────────────────────────────────────────────
export const NAVBAR_HEIGHT = 52;

export const MS_PER_DAY = 86400000;

export const WORKER_URL = 'https://api.alvarotorresb.com';

export const AI_MAX_ATTEMPTS = 3;
export const AI_RETRY_DELAYS_MS = [2000, 4000];
export const AI_PER_ATTEMPT_TIMEOUT_MS = 30000;
export const AI_TEMPERATURE = 0.2;

export const DEFAULT_AUDIT_CYCLE_MONTHS = 12;
export const DEFAULT_MR_CYCLE_MONTHS = 12;

// ─── HEALTH SCORE COMPONENT WEIGHTS ───
export const HEALTH_COMPONENT_WEIGHTS = {
  riskTreatment:        15,
  controlImplementation: 20,
  objectiveAchievement: 10,
  auditCadence:          5,
  mrCadence:             5,
  ncClosure:            10,
  documentCurrency:      8,
  awarenessCoverage:     7,
  competenceCompletion:  7,
  supplierReviewCadence: 8,
  assetInventoryHealth:  5,
};
